export default "__VITE_ASSET__Cdw8Emhq__"